import { useEffect, useState } from "react";
import { useT } from "@hooks";
import { normalizeText } from "@utils";
import SharedCreateDialog, { isDuplicatedName } from "../SharedCreateDialog";

interface Props {
  show: boolean;
  onClose: () => void;
  onSave: (value: string) => void;
  title: string;
  placeholder: string;
  editValue?: string;
  showDuplicateAlert?: boolean;
  duplicateAlertMessage?: string;
  onInputChange?: () => void;
  existingNames?: string[];
  duplicateNameMessage?: string;
}

const DialogCreateType = ({
  show,
  onClose,
  onSave,
  title,
  placeholder,
  editValue,
  showDuplicateAlert = false,
  duplicateAlertMessage = "",
  onInputChange,
  existingNames = [],
  duplicateNameMessage = "",
}: Props) => {
  const t = useT();
  const [error, setError] = useState("");
  const [value, setValue] = useState(editValue || "");

  const isDuplicateName = normalizeText(value) !== normalizeText(editValue) && isDuplicatedName(value, existingNames);

  const handleSubmit = () => {
    if (!value) {
      setError(t("common.label.requiredField"));
      return;
    }

    if (isDuplicateName) return;

    setError("");
    onSave(value);
  };

  const handleClose = () => {
    onClose();
    setValue("");
  };

  const handleValueChange = (newValue: string) => {
    setValue(newValue);
    onInputChange?.();
  };

  useEffect(() => {
    setValue(editValue ?? "");
  }, [editValue, show]);

  return (
    <SharedCreateDialog
      show={show}
      title={title}
      placeholder={placeholder}
      value={value}
      onValueChange={handleValueChange}
      error={error}
      isDuplicateName={isDuplicateName}
      duplicateNameMessage={duplicateNameMessage}
      showDuplicateAlert={showDuplicateAlert}
      duplicateAlertMessage={duplicateAlertMessage}
      onClose={handleClose}
      onSubmit={handleSubmit}
      useOverflow
    />
  );
};

export default DialogCreateType;
